<template>
  <v-dialog
    :value="addNewGalleryImage"
    max-width="1000px"
    @click:outside="closeDialog"
  >
    <v-card dark>
      <v-card-title>
        Přidejte nový obrázek
      </v-card-title>
      <v-card-text>
        <div class="card">
          <div v-if="!loading">
            <div v-if="picture !== null">
              <img
                :src="picture"
                style=" padding:10px;"
              >
            </div>
            <div v-else>
              <img
                src="../../assets/plus.jpg"
                style=" padding:10px;"
                @click="addImage"
              >
              <input
                id="profile"
                ref="fileInputImg"
                style="display:none;"
                type="file"
                accept="image/*"
                @change="previewFile"
              >
            </div>
          </div>
          <div v-else-if="loading">
            <v-progress-circular
              indeterminate
              color="yellow"
            />
          </div>
        </div>
      </v-card-text>
      <v-card-actions style="display:flex; justify-content:space-between">
        <v-btn
          outlined
          @click="closeDialog"
        >
          Zrušit
        </v-btn>
        <v-btn
          outlined
          color="blue"
          @click="addImageFce"
        >
          Přidat
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import db from '../../fb'
import firebase from 'firebase/compat/app'
export default {
  props: {
    addNewGalleryImage: Boolean,
    images: { type: Array, default: null }
  },
  emits: ['close', 'pushImage'],
  data () {
    return {
      picture: null,
      uploadValue: 0,
      loading: false,
      imageData: null

    }
  },
  methods: {
    closeDialog () {
      this.$emit('close')
    },
    addImage () {
      this.$refs.fileInputImg.click()
    },
    previewFile (e) {
      this.uploadValue = 0
      this.picture = null
      this.imageData = e.target.files[0]
      console.log(this.imageData)
      // console.log(e.target.files[0])
      this.uploadProfilePicture()
    },
    uploadProfilePicture () {
      this.loading = true
      this.picture = null
      const storageRef = firebase.storage().ref(`${this.imageData.name}`).put(this.imageData)
      storageRef.on('state_changed', snapshot => {
        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      }, error => { console.log(error.message) },
      () => {
        this.uploadValue = 100
        storageRef.snapshot.ref.getDownloadURL().then((url) => {
          this.picture = url
          console.log(url)
          this.loading = false
        })
      })
    },
    addImageFce () {
      if (this.images.length === 0) {
        const max = 1
        const obj = {
          image: this.picture,
          id: max
        }
        this.$emit('pushImage', obj)
        db.collection('editGallery').doc(max.toString()).set(obj)
      } else {
        const ids = this.images.map(object => {
          return object.id
        })
        console.log(ids)
        const max = Math.max(...ids) + 1
        const obj = {
          image: this.picture,
          id: max
        }
        this.$emit('pushImage', obj)
        db.collection('editGallery').doc(max.toString()).set(obj)
      }
      this.picture = null
      this.imageData = null
      this.uploadValue = 0
    }
  }
}
</script>

<style scoped>
.card{
  display:flex;
  justify-content: center;
}
img{
  cursor: grab;
  width:100%;
  max-width:300px;
}
</style>